import MenuItem from "./MenuItem"
import { ExpandedSideBarProps } from "./Sidebar.types"

export default function ExpandedSideBar({
    applications,
    platformServices,
    setOpenMenuCode,
    openMenuCode,
    activeAppCode,
    onCollapseSideBar }: ExpandedSideBarProps) {
    return <div className="side-menu-container">
        <div className="side-menu-app-container">
            {applications.length > 0 ? (
                <div className="side-menu-list applications-container">
                    <span className="app-type-text">Applications</span>
                    {applications.map((app) => {
                        return (
                            <MenuItem
                                key={app.applicationCode}
                                currentApplication={app}
                                setOpenMenuCode={setOpenMenuCode}
                                openMenuCode={openMenuCode}
                                activeAppCode={activeAppCode}
                            />
                        )
                    })}
                </div>
            ) : null}

            <div className="side-menu-list platform-services-container">
                <span className="app-type-text">Platform services</span>
                {platformServices.map((app) => {
                    return (
                        <MenuItem
                            key={app.applicationCode}
                            currentApplication={app}
                            setOpenMenuCode={setOpenMenuCode}
                            openMenuCode={openMenuCode}
                            activeAppCode={activeAppCode}
                        />
                    )
                })}
            </div>
        </div>
        <div
            className="collapse-text-container"
            onKeyDown={() => { }}
            onClick={onCollapseSideBar}
        >
            <img
                src="/assets/images/chevrons-left.svg"
                className="collapse-icon"
            />
            <div className="collapse-txt">Collapse</div>
        </div>
    </div>
}